export const mia = {
  slug: "mia",
  name: "University of Miami",
  colors: {
    primary1: "#005030",
    text: "#000",
  },
  fonts: {
    base: "Open Sans, sans-serif",
    url: "https://whitelabel.2u.com/cdn/v1/37dc3692-fd1f-475d-8627-745197ebec2f/marketing/whitelabel.fonts.min.css?ver=1.0",
  },
};

